import { memo, useEffect, useState } from "react";
import tw from "twin.macro";
import TopbarMenus from "./TopbarMenus";
import { ECommerce } from "api/AppConfigApi";
import { setBranchId } from "../../utility/HeaderConfig.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useCartContext } from "context/UseCartContext";
import { Link } from "react-router-dom";
// import { reactLocalStorage } from "reactjs-localstorage";
import close from "../../images/Thanshiq/navbar/10001.svg";
import sign from "../../images/Thanshiq/sign.svg";
import con from "../../images/Thanshiq/10019.svg";
import logo from "../../images/MGDM.png";
import { BsHeart } from "react-icons/bs";
import { IoIosHome } from "react-icons/io";
import diamond from "../../images/Thanshiq/navbar/Diamond.svg"
import store from "../../images/Thanshiq/navbar/store.png"
import acc from "../../images/Thanshiq/navbar/account.svg"
import wish from "../../images/Thanshiq/navbar/heart.svg"
import home from "../../images/Thanshiq/navbar/home1.png"
import styled from "styled-components";
import nav2 from "../../images/Thanshiq/diamond mainpage/CityLocation/main/Nav2.svg"
import nav4 from "../../images/Thanshiq/diamond mainpage/CityLocation/main/Nav4.svg"
import nav5 from "../../images/Thanshiq/diamond mainpage/CityLocation/main/Nav5.svg"
import LoginModal from "../LoginModal.js";
import { reactLocalStorage } from "reactjs-localstorage";
import {
  getCustomerId,
  getCustomerName,
  removeCustomerId,
} from "utility/HeaderConfig";
import micro from "../../images/Thanshiq/diamond mainpage/CityLocation/main/icons8-microphone-100.png"
import camora from "../../images/Thanshiq/diamond mainpage/CityLocation/main/camers.svg"
import searchi from "../../images/Thanshiq/diamond mainpage/CityLocation/main/10025.png"

import toast, { Toaster } from "react-hot-toast";
import OpenModal from "components/OpenModal";
import { getAddToCart, getBranchId } from "utility/HeaderConfig.js";
import Noimg from "../../images/no_img.jpg";
import TopBarOffer from "./TopBarOffer.js";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import moment from "moment";
import { filterFormatFromDate, filterFormatToDate } from "utility/Constant";
import { PurityApi } from "api/PurityApi";
import { getPageProductType } from "api/ProductTypeApi";

const TopbarContainer = tw.div`text-black `;

function Topbar({ branch }) {
  const CartTitle = tw.div`text-xs tracking-widest font-semibold text-gray-700`;
  const [media, setMedia] = useState([]);
    const [verifyAmount, setVerifyAmount] = useState(0);
  
  const [branches, setBranches] = useState([]);
  const [viewCart, setViewCart] = useState([]);
  const { data, branchId } = useCartContext();
  const [isShow, setIsShow] = useState(false);
  // const { dispatch } = useCartContext();
  const [open, setOpen] = useState(false);
  const [isAccountDropdownOpen, setIsAccountDropDownOpen] = useState(false);


  const { login, dispatch } = useCartContext();
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get('search')?.toLowerCase() || '';
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    price: "",
    status: "available",
    occasion: '',
    minValue: '',
    maxValue: ''
  });
  const [productType, setProductType] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [productCategory, setCategoryList] = useState([]);

  const diamondType = productType.find((data) => data.name?.toLowerCase().trim() === "diamond");

  const handleAccountIconClick = () => {
    setIsAccountDropDownOpen(!isAccountDropdownOpen);
  }

  const getProductType = () => {
    getPageProductType({ active: 1 }).then((data) => {
      const response = data.response.content || [];
      const pList = response.filter(
        (item) => item.metaProductCategoryList.length > 0 && item.id
      );
      setProductType(pList.reverse());
    });
  };
  const history = useNavigate();

   const checkout = () => {
      if (total <= verifyAmount) {
        if (getCustomerId()) {
          history("/CheckoutPage");
        } else {
          dispatch({ type: "MODAL", payload: "login" });
        }
      }
      // else {
      //   toast.error(`The Purchase Amount Is Shouldn't Be Greater Than ${verifyAmount}`, {
      //     position: "top-right",
      //     duration: 3000
      //   })
      // };
    };

    const toPascalCase = (text) => {
    if (!text) return '';

    return text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const [productSubCate, setProductSubCate] = useState([]);
  const [recentGoldRate, setRecentGoldRate] = useState({
    metaProdTypeName: "Gold",
    rate: "N/A",
    unitType: "",
  });
  const [recentSilverRate, setRecentSilverRate] = useState({
    metaProdTypeName: "Silver",
    rate: "N/A",
    unitType: "",
  });
  //eslint-disable-next-line
  const [recentGold18KRate, setRecentGold18KRate] = useState({
    metaProdTypeName: "Gold",
    rate: "N/A",
    unitType: "",
  });
  const purityRate = (
    <div className="d-flex align-items-center gap-4 mx-4 purity-rate">
      {/* GOLD RATE */}
      <div className="d-inline-flex align-items-center gap-2">
        <i className="bi bi-server" style={{ fontSize: 20, color: "#d4af37" }}></i>
        <div className="text-truncate">
          <span className="text-uppercase fw-bold me-2">{recentGoldRate.metaProdTypeName}</span>
          <span>
            ₹
            {recentGoldRate?.onlineRate > 0
              ? Math.trunc(recentGoldRate.onlineRate)
              : Math.trunc(recentGoldRate.rate) || "-"}
            {recentGoldRate.unitType ? `/${recentGoldRate.unitType}` : ""} ({recentGoldRate.purity})
          </span>
        </div>
      </div>

      {/* SILVER RATE */}
      <div className="d-inline-flex align-items-center gap-2">
        <i className="bi bi-server" style={{ fontSize: 20, color: "#888" }}></i>
        <div className="text-truncate">
          <span className="text-uppercase fw-bold me-2">{recentSilverRate.metaProdTypeName}</span>
          <span>
            {recentSilverRate?.onlineRate > 0
              ? `₹ ${Math.trunc(recentSilverRate.onlineRate)}`
              : recentSilverRate?.rate !== "N/A"
                ? `₹ ${Math.trunc(recentSilverRate.rate)}`
                : ""}
          </span>
          <span>{recentSilverRate.unitType ? `/${recentSilverRate.unitType}` : ""}</span>
        </div>
      </div>
    </div>
  );



  const getProductRate = async () => {
    let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
      createdAtTo: filterFormatToDate(toDate),
    };
    const todayMetalRate = await PurityApi(filterData);
    if (todayMetalRate.errorCode === undefined) {
      let isGoldRateFound = false;
      let isSilverRateFound = false;
      let isGold18KRateFound = false;
      todayMetalRate.response.forEach((item) => {
        if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "gold" &&
          item.purity.includes("22") &&
          !isGoldRateFound
        ) {
          item.purity = "22K";
          setRecentGoldRate(item);
          isGoldRateFound = true;
        } else if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "gold" &&
          item.purity.includes("18") &&
          !isGold18KRateFound
        ) {
          item.purity = "18K";
          isGold18KRateFound = true;
        } else if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "silver" &&
          !isSilverRateFound
        ) {
          setRecentSilverRate(item);
          isSilverRateFound = true;
        }
      });
    }
  };

  const handleSearch = (e) => {
    setSearchInput(e.target.value);
  };

  const getProductSub = async (filterData = {}) => {
    if (!filterData.metaProdTypeEnty) delete filterData.metaProdTypeEnty;
    if (!filterData.metaProdCateEnty) delete filterData.metaProdCateEnty;
    await getAllProductSubCate(filterData).then((data) => {
      let response = data.response;
      setProductSubCate(response);
    });
  };


  const logout = () => {
    removeCustomerId();
    dispatch({ type: "LOGIN", payload: null });
    dispatch({ type: "ADD", payload: null });
    reactLocalStorage.remove("CartList");
    toast.success("Logged out successfully...!", {
      duration: 1000,
      position: "top-right",
    });
    setTimeout(() => {
      navigate("/");
    }, 1000);
  };

  const checkLogin = () => {
    if (getCustomerId()) {
      navigate("/MyScheme");
    } else {
      navigate("/LoginPage");
    }
  };


  let navigate = useNavigate();

  const handleContact = () => {
    navigate = ("/contact");
  }

  useEffect(() => {
    getAllBrachDetails();
    socialMedia();
    getProductRate();
    getProductType();
    // reactLocalStorage.setObject('branchName',branch.branchName)
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Apply filtering based on searchQuery
    if (searchQuery && allProducts.length > 0) {
      const filtered = allProducts.filter((product) =>
        product.name.toLowerCase().includes(searchQuery)
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(allProducts);
    }
  }, [searchQuery, allProducts]);

  const getAllBrachDetails = () => {
    const moduleName = "endpoint";
    ECommerce(moduleName).then((data) => {
      const branchResponse = JSON.parse(data.response.moduleField);
      setBranches(branchResponse);
    });
  };

  const socialMedia = () => {
    let filter = "social_media_config";
    ECommerce(filter).then((data) => {
      let SOCIALMEDIA = JSON.parse(data.response.moduleField);
      setMedia(SOCIALMEDIA);
    });
  };

  const selectBranch = (branchId) => {
    setBranchId(branchId);
    dispatch({ type: "BRANCHID", payload: branchId });
    navigate("/");
    // reactLocalStorage.setObject('branchName',branch.branchName)

  };
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (e) => {

    setIsVisible(false);
    localStorage.setItem("offerNavbarClosed", "true");
  };



  const [total, setTotal] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState("");
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const getAddToCartDetails = async () => {
    let filter = "savings_scheme_app";
    ECommerce(filter).then((data) => {
      let showButton = JSON.parse(data.response.moduleField);
      let isShowData = showButton.filter(
        (item) => item.key === "IS_ECOMM_ADD_TO_CART_ENABLED"
      );
      setIsShow(isShowData[0].value);
    });
  };
  const CurrentPath = () => {
    if (data && data.length > 0) {
      navigate("/CartPage", { state: { viewCart } });
    }
  };
  if (!isVisible) return null;


 const cart = (
    <div className="position-relative mx-2 order-0 order-sm-3 p-0 hover-trigger ">
      {/* {!!isShow && ( */}
      <span
        className="text-black cart-icon"
        tw="cursor-pointer"
        onClick={CurrentPath}
      >
        <i className="bi bi-cart4" tw="text-2xl leading-3"></i>
        {data && data.length > 0 ? (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill "
            tw="bg-custom-100"
            style={{ padding: "2px 6px", lineHeight: "16px" }}
          >
            {data?.length}
          </span>
        ) : (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
            tw="bg-custom-100"
            style={{ padding: "2px 6px", lineHeight: "16px" }}
          >
            {
              JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]")
                .length
            }
          </span>
        )}
      </span>
      {/* )} */}
      {/* <div
        className="position-absolute end-0 py-3 bg-white rounded border hover-target header-cart"
        tw="w-96 shadow-2xl rounded-lg duration-1000"
        style={{ top: "10px" }}>
        <div className="d-flex justify-content-between px-3 ">
          <CartTitle style={{ color: "#811331", fontFamily: "Fraunces,serif", fontSize: "10px" }}>
            cart
          </CartTitle>
          <span style={{ color: "#811331", fontFamily: "Fraunces,serif", fontSize: "20px" }} tw="text-xs tracking-widest">
            ({data && data.length > 0 ? data.filter((cartItem) => cartItem.branchId === getBranchId()).length : JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]").length} Item)
          </span>
        </div>

        {viewCart.length > 0 ? (
          <div className="main-content ">
            {viewCart.map((list, index) => (
              <div key={index}>
                <div className="d-flex justify-content-center">
                  <div className="row m-2 m-0 " style={{ border: "1px solid #eec0c8", borderRadius: "10px", width: "85%" }}>
                    <div className="col-md-3 m-2">
                      <img style={{ width: "80px", height: "80px", borderRadius: "10px" }} src={list.images.includes("@#@") && list.images !== "@#@" ? list.images.split("@#@")[0] : Noimg} alt="Mahalaxmi Gold And Diamond-product" className="border m-1 border-1" />
                    </div>
                    <div className="col-md-6 ">
                      <div className="d-flex justify-content-between">
                        <p id="CartFontStyle" tw="text-sm mb-1">{toPascalCase(list.title)}</p>
                        <span className="border-bottom text-danger ml-2" tw="text-xs cursor-pointer" onClick={() => setShowModal(list.skv)}>
                          <i className="bi bi-x-lg"></i>
                        </span>
                      </div>
                      <div className="Qty d-flex justify-content-start">
                        Qty: <span style={{ marginLeft: "5px" }}>{list.quantity}</span>
                      </div>
                      <div className="d-flex justify-content-start">
                        <div className=" price ">Price:</div>
                        <div className=" price">₹{list.total && Math.trunc(list.total)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div
              className="d-flex w-100 justify-content-between align-items-center"
              tw=" py-3 px-4  " style={{ background: "#eec0c8", color: "#811331" }}
            >
              <span className="cartHead" tw="text-sm ">Sub Total </span>:
              <span tw="text-base font-semibold">
                {" "}
                ₹ {total ? Math.trunc(total) : 0}
              </span>
            </div>
            <div className=" col-10 d-flex m-auto justify-content-between " tw="pt-5">
              <button onClick={() => history("CartPage", { state: { viewCart } })}
                className="p-2 w-50 cartHead"
                style={{ border: "1px solid #eec0c8", background: "#eec0c8", color: "#811331", borderRadius: "25px" }}>
                View Cart
              </button>

              <button onClick={checkout} className="p-2 w-30 checkOut" style={{ border: "1px solid #811331", background: "#811331", color: "white", borderRadius: "25px" }}>
                Quick CheckOut
              </button>
            </div>
          </div>
        ) : (
          <div className="col-md-12 empty-wrapper">
            <img
              className="trash-icon m-auto"
              tw=" w-3/5 sm:w-1/4"
              alt="empty bag"
              src="data:image/svg+xml;base64,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"
            />
            <h3 className="cartHead" tw=" uppercase py-5 font-extrabold text-center text-base">
              Your Bag is Empty
            </h3>
          </div>
        )}
      </div> */}
    </div>
  );


  return (


    <TopbarContainer className="text-dark " color="light">
      <div>
        <TopBarOffer />
      </div>
      <nav
        className="navbar-expand-lg fixed-top px-3"
        style={{ backgroundColor: "#ffffff", zIndex: 1000 }}
      >
        <div className="d-flex flex-row justify-content-between align-items-center p-0 w-100 flex-wrap">

          {/* Logo */}
          <div className="order-1 flex-shrink-0">
            <Link to="/" className="navbar-brand">
              <img
                src={logo}
                alt="Mahalaxmi Gold And Diamond"
                className="img-fluid"
                style={{ width: "auto" }}
              />
            </Link>
          </div>

          {/* Purity */}
          <div className="order-2 flex-shrink-1 text-center mx-2">{purityRate}</div>

          {/* Offers Button */}
          <div className="order-3 flex-shrink-0">
            <button
              onClick={() => navigate("/Offers")}
              className="btn btn-sm px-3"
              style={{
                color: "white",
                borderRadius: "5px",
                background:
                  "linear-gradient(to right, rgba(70, 46, 46, 0.86), rgba(240, 105, 179, 0.66))",
              }}
            >
              <b className="d-none d-sm-inline">OFFERS</b>
            </button>
          </div>

          {/* Icons */}
          <div className="order-4 d-flex align-items-center gap-3 flex-shrink-0 flex-nowrap">
            <Link to="/Contact">
              <img src={nav2} style={{ width: "22px", height: "32px" }} alt="City" />
            </Link>

            <Link to="/WishList">
              <img src={wish} style={{ width: "22px", height: "32px" }} alt="Wishlist" />
            </Link>

            {cart}
            
            <div
              className="dropdown"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
              style={{ position: "relative" }}
            >
              <img
                src={nav4}
                alt="Account"
                style={{ width: "22px", height: "32px", cursor: "pointer" }}
                onClick={handleAccountIconClick}
              />
              {isAccountDropdownOpen && open && (
                <div
                  className="dropdown-menu show mt-2"
                  style={{
                    position: "absolute",
                    top: "18px",
                    left: "-180px",
                    minWidth: "220px",
                    zIndex: 999,
                    borderRadius: "8px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff"
                  }}
                >
                  {login ? (
                    <>
                      <div className="border-bottom">{getCustomerName()}</div>
                      <span onClick={checkLogin} className="dropdown-item">
                        <i className="bi bi-person-workspace"></i> My Scheme
                      </span>
                      <Link to="/WishList" className="dropdown-item">
                        <i className="bi bi-heart"></i> My Wishlist
                      </Link>
                      <Link to="/MyPurchase" className="dropdown-item">
                        <i className="bi bi-bag"></i> My Purchase
                      </Link>
                      <Link to="/AddAddress" className="dropdown-item">
                        <i className="bi bi-geo-alt-fill"></i> My Address
                      </Link>
                      <span onClick={logout} className="dropdown-item">
                        <i className="bi bi-box-arrow-in-left"></i> Logout
                      </span>
                    </>
                  ) : (
                    <div className="d-flex flex-column align-items-center p-3" style={{ gap: '10px' }}>
                      <button onClick={() => dispatch({ type: "MODAL", payload: "login" })} className="menu-item special d-flex align-items-center gap-2 p-2 w-100">
                        <img className="menu-icon" src={sign} alt="Sign Up" /> Login / Sign Up
                      </button>
                      <Link to="/Contact" className="menu-item d-flex align-items-center gap-2 p-2 w-100">
                        <img className="menu-icon" src={con} alt="Contact Us" />
                        Contact Us
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>


      <div style={{ paddingTop: "30px" }}>
      </div>
      <TopbarMenus />
    </TopbarContainer>
  );
}

export default memo(Topbar);
